/* =========================================================================
   CUSTOM PRODUCT INFO JAVASCRIPT (Adaptive Frame + Hype Support)
   ========================================================================= */

document.addEventListener('DOMContentLoaded', () => {
  
  const initProductInfo = () => {
    const customSections = document.querySelectorAll('[data-custom-product-section]');
    
    customSections.forEach(sectionEl => {
  if (sectionEl.dataset.initialized) return;
  sectionEl.dataset.initialized = true;

  const configEl = sectionEl.querySelector('.custom-product-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.error('custom-product-info: failed to parse config JSON', e);
    return;
  }
  const sectionId = config.sectionId;

  // ==========================================
  // 1. INJECT ADAPTIVE FRAME & BADGE
  // ==========================================
  if (config.hasImageStyleBlock) {
    const topLevelGallery = sectionEl.querySelector('.product-gallery');
    const mainImageContainer = sectionEl.querySelector('.product-gallery__main, .gallery-wrap, .product_slider, .product__media-list');

    if (topLevelGallery && mainImageContainer) {
      topLevelGallery.classList.add('is-adaptive-frame');
      
      if (config.showProductBadge && config.productBadgeText !== '' && (config.isSale || config.forceBadge)) {
        const badge = document.createElement('div');
        badge.className = 'product-sale-badge adaptive-badge';
        badge.textContent = config.productBadgeText;
        badge.style.setProperty('--sale-badge-bg', config.productBadgeColor);
        mainImageContainer.appendChild(badge);
      }
      setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 100);
    }
  }

  // ==========================================
  // 2. INJECT METAOBJECT LINKS
  // ==========================================
  const metaLinksTemplate = sectionEl.querySelector(`#product-meta-links-payload-${sectionId}`);
  const productTitle = sectionEl.querySelector('h1.product_name, h1.product-title, .product__title, .title');
  
  if (metaLinksTemplate && productTitle) {
    const metaLinksHTML = metaLinksTemplate.content.cloneNode(true);
    if (metaLinksHTML.querySelector('.product-meta-btn')) {
      productTitle.parentNode.insertBefore(metaLinksHTML, productTitle);
    }
  }

  // ==========================================
  // 3. INJECT HYPE FORM (COMING SOON OVERRIDE)
  // ==========================================
  const hypeFormTemplate = sectionEl.querySelector(`#hype-form-payload-${sectionId}`);
  if (hypeFormTemplate) {
    const hypeFormHTML = hypeFormTemplate.content.cloneNode(true);
    
    const targetContainer = sectionEl.querySelector('.purchase-details, .product_form, .product-form, [data-product-form]');
    
    if (targetContainer) {
      const nativeForms = targetContainer.querySelectorAll('form');
      nativeForms.forEach(f => f.style.display = 'none');
      
      targetContainer.parentNode.insertBefore(hypeFormHTML, targetContainer);
    } else if (productTitle) {
      productTitle.parentNode.insertBefore(hypeFormHTML, productTitle.nextSibling);
    }
  }

  // ==========================================
  // 4. INJECT CUSTOM VARIANTS OR SINGLE PRICE
  // ==========================================
  const nativeForm = sectionEl.querySelector('form[action*="/cart/add"], .product_form, .product-form, form[id^="product_form"], [data-product-form], .shopify-product-form');
  
  if (nativeForm && !hypeFormTemplate) { 
    const variantsTemplate = sectionEl.querySelector(`#product-variants-payload-${sectionId}`);
    const singlePriceTemplate = sectionEl.querySelector(`#product-single-price-payload-${sectionId}`);
    
    // --- A) HANDLE PRODUCTS WITH VARIANTS (PROXY METHOD + CUSTOM PRICE) ---
        if (variantsTemplate) {
          // 1. Hide native swatch/dropdown UI (but keep the native form active in the background!)
          const nativeSelectors = nativeForm.querySelectorAll('.selector-wrapper, .swatch_options, .product-options, .select, fieldset, .variant-wrapper, .product-form__variants, .swatch');
          nativeSelectors.forEach(el => el.style.display = 'none');

          // 2. Clone our custom HTML
          const variantsHTML = variantsTemplate.content.cloneNode(true);
          const variantDataEl = variantsHTML.querySelector('.product-variant-data');
          let variantData = null;
          if (variantDataEl) {
            try {
              variantData = JSON.parse(variantDataEl.textContent);
            } catch (e) {
              console.error('custom-product-info: failed to parse variant data JSON', e);
            }
          }
          
          // 3. INJECT THE FULL TEMPLATE (This restores your custom Price Wrapper AND Pills)
          nativeForm.insertBefore(variantsHTML, nativeForm.firstChild);

          // Now that the price is on the screen, we can target it
          const priceWrapper = nativeForm.querySelector('.product-dynamic-price-wrapper');

          // 4. Update Custom Pill UI (Fixed logic that looks at ALL combinations, preventing hallucinations)
          const updateAvailability = () => {
            if (!variantData) return;
            const optionGroups = Array.from(nativeForm.querySelectorAll('.product-variant-group'));
            
            const currentSelections = optionGroups.map(group => {
              const checked = group.querySelector('input[type="radio"]:checked');
              return checked ? checked.value : null;
            });

            optionGroups.forEach((group, groupIndex) => {
              const radios = group.querySelectorAll('input[type="radio"]');
              radios.forEach(radio => {
                const testValue = radio.value;
                // Fix selections for higher-priority (lower-index) groups, test this group,
                // and null out lower-priority groups — prevents higher-tier pills from
                // being marked sold-out based on an incompatible current lower-tier selection.
                const hypotheticalSelections = currentSelections.map((sel, idx) => {
                  if (idx === groupIndex) return testValue;
                  if (idx > groupIndex) return null;
                  return sel;
                });

                // Look for ALL matching variants in the JSON
                const matchingVariants = variantData.filter(v => {
                  return v.options.every((opt, idx) => {
                    return hypotheticalSelections[idx] === null || opt === hypotheticalSelections[idx];
                  });
                });

                const pillContainer = radio.closest('.product-pill-container');
                if (!pillContainer) return;

                // If the combination exists AND at least one version is available, keep it active
                if (matchingVariants.length > 0 && matchingVariants.some(v => v.available)) {
                  pillContainer.classList.remove('is-sold-out');
                } else {
                  pillContainer.classList.add('is-sold-out'); // Visually cross out the pill
                }
              });
            });
          };

          // 5. Update Custom Price Text
          const updateDynamicPrice = () => {
            if (!priceWrapper || !variantData) return;
            
            // Gather current selections
            const selectedOptions = [];
            const optionGroups = nativeForm.querySelectorAll('.product-variant-group');
            optionGroups.forEach(group => {
              const checked = group.querySelector('input[type="radio"]:checked');
              if (checked) selectedOptions.push(checked.value);
            });

            // Find exact match for the selected combination
            const matchedVariant = variantData.find(v => 
              v.options.length === selectedOptions.length && 
              v.options.every((opt, idx) => opt === selectedOptions[idx])
            );

            const innerWrapper = priceWrapper.querySelector('.product-price-inner');
            if (innerWrapper) {
              if (matchedVariant) {
                 innerWrapper.innerHTML = `
                  <span class="product-price">${matchedVariant.price}</span>
                  ${matchedVariant.compare_at ? ` <s class="product-compare-price">${matchedVariant.compare_at}</s>` : ''}
                `;
              } else {
                 // The combo is completely missing from the matrix
                 innerWrapper.innerHTML = `<span class="product-price" style="opacity: 0.6;">Unavailable</span>`;
              }
            }
          };

          // Helper: find the native <select> for a given 0-based option index.
          // Uses specific data attributes first, then falls back to positional lookup
          // of .single-option-selector elements only (avoids accidentally grabbing
          // quantity selects or other unrelated <select> elements in the form).
          const getNativeSelect = (optionIdx) => {
            const optionNum = optionIdx + 1;
            return (
              nativeForm.querySelector(`[data-option="option${optionNum}"]`) ||
              nativeForm.querySelector(`[data-index="option${optionNum}"]`) ||
              nativeForm.querySelector(`select[name="option${optionNum}"]`) ||
              nativeForm.querySelectorAll('.single-option-selector')[optionIdx] ||
              null
            );
          };

          // Helper: read all current custom pill selections and sync the native form.
          // Sets each native option select AND the hidden variant ID input so every
          // theme pattern (option-select-based and variant-ID-based) gets updated.
          const syncNativeForm = () => {
            const currentSelections = Array.from(
              nativeForm.querySelectorAll('.product-variant-group')
            ).map(group => {
              const checked = group.querySelector('input[type="radio"]:checked');
              return checked ? checked.value : null;
            });

            // Set each native option select silently
            let lastNativeSelect = null;
            currentSelections.forEach((value, idx) => {
              if (!value) return;
              const sel = getNativeSelect(idx);
              if (sel) {
                sel.value = value;
                lastNativeSelect = sel;
              }
            });

            // Fire one change event on the last select to wake up the theme's variant logic
            if (lastNativeSelect) {
              lastNativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // Also set input[name="id"] directly — works for themes that skip option
            // selects and watch the variant ID input instead
            const validSelections = currentSelections.filter(Boolean);
            if (variantData && validSelections.length > 0) {
              const matched = variantData.find(v =>
                v.options.length === validSelections.length &&
                v.options.every((opt, idx) => opt === validSelections[idx])
              );
              if (matched && matched.id) {
                const variantInput = nativeForm.querySelector('input[name="id"]');
                if (variantInput) {
                  variantInput.value = matched.id;
                  variantInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            }

            window.dispatchEvent(new Event('resize'));
          };

          // 6. THE PROXY REMOTE CONTROL (Click Listeners)
          const injectedRadios = nativeForm.querySelectorAll('.product-pill-container input[type="radio"]');
          injectedRadios.forEach(radio => {
            radio.addEventListener('change', function() {
              updateAvailability();
              updateDynamicPrice();
              syncNativeForm();
            });
          });

          // 7. Force Initialization on Page Load
          const initialPills = nativeForm.querySelectorAll('.product-pill-container input[type="radio"]:checked');
          if (initialPills.length > 0) {
            updateAvailability();
            updateDynamicPrice();
            syncNativeForm();
          } else {
            updateAvailability();
          }
        }
         
    // --- B) HANDLE SINGLE PRICE ---
    else if (singlePriceTemplate) {
      const priceHTML = singlePriceTemplate.content.cloneNode(true);
      nativeForm.insertBefore(priceHTML, nativeForm.firstChild);
    }

    // ==========================================
    // 5. INJECT BUNDLE BUTTON
    // ==========================================
    const bundleBtnTemplate = sectionEl.querySelector(`#product-bundle-link-payload-${sectionId}`);
    if (bundleBtnTemplate) {
      const bundleBtnHTML = bundleBtnTemplate.content.cloneNode(true);
      const atcWrapper = nativeForm.querySelector('.purchase-details, .product-add-to-cart, .payment-buttons, button[name="add"], .add_to_cart, .button--add-to-cart');
      
      if (atcWrapper) {
        atcWrapper.parentNode.insertBefore(bundleBtnHTML, atcWrapper);
      } else {
        nativeForm.appendChild(bundleBtnHTML);
      }
    }
  }
});
};

initProductInfo();
document.addEventListener('shopify:section:load', initProductInfo);
});